import axios from '../../../build/http-requests/axios-common'
import Vue from 'vue'

export default {
  state: {
  },

  mutations: {
  },

  actions: {
    searchConciliationReport: ({ commit }, filter) => {
      return new Promise((resolve, reject) => {
        axios.post('/conciliationReport/searchConciliationReport', filter).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    searchConciliationReportToFile: ({ commit }, filter) => {
      return new Promise((resolve, reject) => {
        axios.post('/conciliationReport/searchConciliationReportToFile', filter, {responseType: 'blob'}).then(response => {
          let currentdate = new Date()
          let datetime = currentdate.getDate().toString() +
            (currentdate.getMonth() + 1).toString() +
            currentdate.getFullYear().toString() + '_' +
            currentdate.getHours() +
            currentdate.getMinutes() +
            currentdate.getSeconds()
          let blob = new Blob([response.data])
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = Vue.i18n.translate('downloads.labels.relatorioConciliacao') + datetime + '.csv'
          link.click()
          resolve()
        }).catch((error) => {
          reject(error)
        })
      })
    },
    getBankStatementById: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.get('/bankStatement/getBankStatementById', { params: { idMovimentacaoBancaria: data } })
          .then(response => {
            resolve(response)
          }).catch((error) => {
            reject(error)
          })
      })
    },
    getHistoricConciliationReport: ({ commit }, data) => {
      return new Promise((resolve, reject) => {
        axios.get(data.url, { params: { conciliationReportId: data.conciliationReportId } }).then(response => {
          resolve(response)
        }).catch((error) => {
          reject(error)
        })
      })
    }
  },

  getters: {
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/conciliationReport.js